import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { HttpClient, HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { MenuModule } from 'primeng/menu';
import { AppRoutingModule } from './app-routing.module';
import { SidebarComponent } from './shared/sidebar/sidebar.component';
import { HrmHeaderComponentModule } from './features/hrm-header/hrm-header-component.module';
import { QuickLauncherComponent } from './shared/quick-launcher/quick-launcher.component';
import {MenubarModule} from 'primeng/menubar';
import { AvatarModule } from 'primeng/avatar';
import { ToolbarModule } from 'primeng/toolbar';
import { DefaultLayoutComponent } from './containers/default-layout';
import { AppComponent } from './app.component';
import { BrowserModule } from '@angular/platform-browser';
import { ChartModule } from 'primeng/chart';
import { TableModule } from 'primeng/table';
import { ButtonModule } from 'primeng/button';
import { StyleClassModule } from 'primeng/styleclass';
import { PanelMenuModule } from 'primeng/panelmenu';
import { NgxSpinnerModule } from 'ngx-spinner';
import { ToastModule } from 'primeng/toast';
import { ConfirmationService, MessageService } from 'primeng/api';
import { DialogService } from 'primeng/dynamicdialog';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { AuthService } from './services/auth/auth.service';
import { AppApiService } from './services/app.service';
import { AuthGuardService } from './services/auth/auth-guard.service';
import { AuthInterceptor } from './services/auth/auth-interceptor';
import { DatePipe, HashLocationStrategy, LocationStrategy } from '@angular/common';
import { TieredMenuModule } from 'primeng/tieredmenu';
import {TranslateModule, TranslateLoader, TranslateService} from '@ngx-translate/core';
import {TranslateHttpLoader} from '@ngx-translate/http-loader';
import { OverlayPanelModule } from 'primeng/overlaypanel';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import {AuthCallbackComponent} from './auth-callback/auth-callback.component';
import { DropdownModule } from 'primeng/dropdown';
import {appConfigProvide, AppConfigService } from 'src/config/app-config.service';
import { AuthConfigModule } from 'src/config/auth.config.module';
import { LanguageService } from './services/language.service';
export function HttpLoaderFactory(httpClient: HttpClient) {
  return new TranslateHttpLoader(httpClient);
}
export function createTranslateLoader(http: HttpClient) {
  return new TranslateHttpLoader(http, './assets/i18n/', '.json');
}

function APP_INITIALIZER() {

}

@NgModule({
  declarations: [
    AppComponent,
    DefaultLayoutComponent,
    SidebarComponent,
    QuickLauncherComponent,
    AuthCallbackComponent
  ],
  imports: [
    BrowserAnimationsModule,
    BrowserModule,
    AppRoutingModule,
    TieredMenuModule,
    FormsModule,
    HttpClientModule,
    OverlayPanelModule,
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient]
      }
    }),
    MenubarModule,
    AvatarModule,
    ToolbarModule,
    ChartModule,
    MenuModule,
    TableModule,
    StyleClassModule,
    PanelMenuModule,
    ButtonModule,
    NgxSpinnerModule,
    ConfirmDialogModule,
    ToastModule,
    TranslateModule,
    DropdownModule,
    AuthConfigModule,
    HrmHeaderComponentModule
  ],
  providers: [
    LanguageService,
    {
      provide: APP_INITIALIZER,
      deps: [
        AppConfigService
      ],
      multi: true,
      useFactory: appConfigProvide
    },
    AppConfigService,
    MessageService,
    DialogService,
    AuthService,
    AppApiService,
    DatePipe,
    ConfirmationService,
    AuthGuardService,
    { provide: HTTP_INTERCEPTORS, useClass: AuthInterceptor, multi: true },
  ],

  bootstrap: [AppComponent]
})
export class AppModule { }
